import { jsxs as o, jsx as C } from "react/jsx-runtime";
const e = ({ size: r, className: l }) => /* @__PURE__ */ o(
  "svg",
  {
    className: l,
    fill: "none",
    height: r,
    viewBox: "0 0 18 18",
    width: r,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          d: "M15.797 5.935L9.53399 0.306C9.46478 0.244127 9.38336 0.197463 9.295 0.169006C9.21922 0.144461 9.14055 0.130004 9.061 0.126007C8.95501 0.12689 8.85077 0.153137 8.757 0.202545C8.66323 0.251953 8.58265 0.323083 8.522 0.410004L8.513 0.423004L8.501 0.433014L2.33 5.923C2.26727 5.97905 2.21651 6.04719 2.18078 6.12335C2.14506 6.19951 2.1251 6.28211 2.12211 6.36618C2.11912 6.45025 2.13316 6.53404 2.16339 6.61255C2.19361 6.69105 2.23941 6.76264 2.298 6.823C2.41757 6.94456 2.57899 7.01596 2.74937 7.02264C2.91975 7.02933 3.08626 6.97082 3.21499 6.85901L8.186 2.43201L8.408 2.23199V12.09C8.40681 12.1735 8.42209 12.2565 8.45295 12.3341C8.48382 12.4117 8.52968 12.4825 8.5879 12.5424C8.64613 12.6023 8.71556 12.6501 8.79228 12.6832C8.86899 12.7162 8.95148 12.7338 9.035 12.735H9.059C9.22403 12.7389 9.3841 12.6785 9.5054 12.5665C9.62669 12.4546 9.6997 12.2998 9.709 12.135C9.709 12.1203 9.709 12.1053 9.709 12.09V2.19L9.932 2.39001L14.902 6.871C15.0288 6.98466 15.1944 7.04533 15.3647 7.0405C15.5349 7.03566 15.6968 6.96568 15.817 6.845L15.827 6.83502C15.8857 6.7748 15.9317 6.70331 15.962 6.62488C15.9924 6.54645 16.0067 6.46267 16.0039 6.3786C16.0011 6.29453 15.9813 6.21191 15.9457 6.13568C15.9102 6.05945 15.8596 5.99118 15.797 5.935Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M9.83901 12.21C9.83901 12.218 9.83901 12.226 9.83901 12.234C9.83601 12.226 9.83801 12.218 9.83901 12.21Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M9.80299 12.354C9.80299 12.364 9.795 12.373 9.792 12.382C9.796 12.373 9.79999 12.364 9.80299 12.354Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M0.646011 9.90504C0.476847 9.90422 0.314174 9.97009 0.193253 10.0884C0.072331 10.2067 0.00289202 10.3679 0 10.537V17.368C0.00289352 17.5373 0.072466 17.6987 0.193604 17.817C0.314741 17.9353 0.477666 18.0011 0.647003 18H17.353C17.5223 18.0011 17.6851 17.9353 17.806 17.8169C17.927 17.6986 17.9964 17.5372 17.999 17.368V10.537C17.9924 10.37 17.9214 10.2119 17.8009 10.096C17.6804 9.98017 17.5197 9.91544 17.3525 9.91544C17.1853 9.91544 17.0246 9.98017 16.9041 10.096C16.7836 10.2119 16.7126 10.37 16.706 10.537V16.737H1.29201V10.537C1.28912 10.3679 1.21969 10.2067 1.09877 10.0884C0.977849 9.97009 0.815175 9.90422 0.646011 9.90504Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
export {
  e as ShareApple
};
